import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { GetMusicBoxContentsRequest } from './getmusicboxcontentsrequest';
import { GET } from '../../api';

export class GetMusicBoxContentsAPI extends SixdeeCRBTAPI<GetMusicBoxContentsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/music-box-contents
        return "music-box-contents"+"?"+"toneCode="+ this.getRequest().getMusicBoxContentsRequest().getToneCode()+"&"+
               "language="+ this.getRequest().getMusicBoxContentsRequest().getLanguage()+"&"+
               "type="+ this.getRequest().getMusicBoxContentsRequest().getType()+"&"+
               "pageNo="+ this.getRequest().getMusicBoxContentsRequest().getPageNo()+"&"+
               "perPageCount="+ this.getRequest().getMusicBoxContentsRequest().getPerPageCount()+"&"+
               "clientTxnId=25062020";
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/getmusicboxcontents/getmusicboxcontentsapi.tsx